import { FC } from 'react';
import { useLoggedinUser } from '@hooks';
import { Avatar, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IUserInfoProps {
	sidebarCollapsed?: boolean;
}

export const UserInfo: FC<IUserInfoProps> = ({ sidebarCollapsed }) => {
	const { t } = useTranslation('portal');
	const user = useLoggedinUser();

	const activeOrganization = user?.assumedOrganization?.name || user?.organization?.name;
	const activeRole = user?.assumedRole?.name || user?.role?.name;
	const userRoles = [user?.isAdmin?.() ? t('admin') : undefined, activeRole].filter(Boolean);

	return user ? (
		<Stack direction="column" alignItems="center" spacing={1}>
			<Avatar sx={{ backgroundColor: 'primary.main', width: 64, height: 64 }}>{user.getAvatarLetters?.()}</Avatar>
			{!sidebarCollapsed ? (
				<>
					<Typography sx={{ textAlign: 'center' }}>
						{(user.name && user.surname ? `${user.name} ${user.surname[0]}.` : user.email) || ''}
					</Typography>
					<Typography variant="body2" sx={{ textAlign: 'center' }}>
						{[activeOrganization, userRoles.join(' & ')].filter(Boolean).join(' - ')}
					</Typography>
				</>
			) : null}
		</Stack>
	) : null;
};
